import { BaseParam } from "./BaseParams";

export class GetEditionParams extends BaseParam {
    constructor(state) {
        super(state)
        if (state == null)
            state = {};

        const { id = null, parentEditionAttachmentTypeId = null, magazineId = null, magazineName = null, number = '', competenceDateFrom = null, competenceDateTo = null, description = ''  } = state;

        this.id = id;
        this.parentEditionAttachmentTypeId = parentEditionAttachmentTypeId;
        this.magazineId = magazineId;
        this.magazineName = magazineName;
        this.number = number;
        this.publicationDateFrom = competenceDateFrom; //PublicationDate
        this.publicationDateTo = competenceDateTo;
        this.description = description; //etichetta
        this.ordering.orderPropertyName = 'competenceDateFrom';
        this.ordering.order = -1;

    }
}



// WEBPACK FOOTER //
// ./src/APIModels/getEditionParams.js